// Utility function to store data in localStorage
const setLocalStorageData = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};

// Utility function to retrieve data from localStorage
const getLocalStorageData = (key) => {
  const data = localStorage.getItem(key);

  return data ? JSON.parse(data) : null;
  // return data ? (typeof data === "string" ? data : JSON.parse(data)) : null;
};

const formatAmount = (amount) => {
  if (amount === null || amount === undefined) return "0.00";

  return Number(amount).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export { setLocalStorageData, getLocalStorageData, formatAmount };
